define("settings/components/downgrade/team-members", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--card u--m__b" data-test-id="team-members">
    <table class="o--table o--table--condensed o--table--sort o--table--hover u--m__b__0">
      <thead>
        <tr>
          <th class="u--text--left">
            <p class="u--m__tb__xs">
              <span class="u--text--md u--text--bold">
                {{t "shared_words.users"}}
              </span>
            </p>
          </th>
        </tr>
      </thead>
  
      <tbody>
        <div class="tDG--tableScroll tDG--tableScroll--lg u--p__0">
          {{#each @teamMembers as |teamMember|}}
            <Downgrade::TeamMember
              @removeTeamMember={{fn @removeTeamMember teamMember}}
              @restoreTeamMember={{fn @restoreTeamMember teamMember}}
              @teamMember={{teamMember}}
              @teamMembersToRemove={{@teamMembersToRemove}}
            />
          {{/each}}
        </div>
      </tbody>
    </table>
  </div>
  */
  {
    "id": "pwtzhm+R",
    "block": "[[[10,0],[14,0,\"o--card u--m__b\"],[14,\"data-test-id\",\"team-members\"],[12],[1,\"\\n  \"],[10,\"table\"],[14,0,\"o--table o--table--condensed o--table--sort o--table--hover u--m__b__0\"],[12],[1,\"\\n    \"],[10,\"thead\"],[12],[1,\"\\n      \"],[10,\"tr\"],[12],[1,\"\\n        \"],[10,\"th\"],[14,0,\"u--text--left\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"u--m__tb__xs\"],[12],[1,\"\\n            \"],[10,1],[14,0,\"u--text--md u--text--bold\"],[12],[1,\"\\n              \"],[1,[28,[35,0],[\"shared_words.users\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,\"tbody\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tDG--tableScroll tDG--tableScroll--lg u--p__0\"],[12],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,1]],null]],null],null,[[[1,\"          \"],[8,[39,3],null,[[\"@removeTeamMember\",\"@restoreTeamMember\",\"@teamMember\",\"@teamMembersToRemove\"],[[28,[37,4],[[30,3],[30,2]],null],[28,[37,4],[[30,4],[30,2]],null],[30,2],[30,5]]],null],[1,\"\\n\"]],[2]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@teamMembers\",\"teamMember\",\"@removeTeamMember\",\"@restoreTeamMember\",\"@teamMembersToRemove\"],false,[\"t\",\"each\",\"-track-array\",\"downgrade/team-member\",\"fn\"]]",
    "moduleName": "settings/components/downgrade/team-members.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});